<template>
  <div id="treeView">
    <div class="backgroundFrame">
      <img class="background" src="@/assets/img/Sky.jpg">
      <img class="background" src="@/assets/img/Mountains.png">
      <img class="background" src="@/assets/img/Ground3.png">
      <img class="background" src="@/assets/img/Ground2.png">
      <img class="background" src="@/assets/img/Ground1.png">
    </div>
    <div id="balloonLayer">
      <img id="balloon1" src="@/assets/img/balloon1.svg" width="50px">
      <img id="balloon2" src="@/assets/img/balloon2.svg" width="50px">
      <img id="balloon3" src="@/assets/img/balloon2.svg" width="50px">
      <img id="balloon4" src="@/assets/img/balloon1.svg" width="50px">
    </div>
    <div class="midgroundFrame">
      <img class="midground" src="@/assets/img/Forest3.png">
      <img class="midground" src="@/assets/img/Forest2.png">
      <img class="midground" src="@/assets/img/Forest1.png">
    </div>
    <div class="foregroundFrame">
      <img class="foreground" src="@/assets/img/Bush_right.png">
      <img class="foreground2" src="@/assets/img/Bush_mobile2.png">
    </div>
    <div class="foregroundFrame">
      <img class="foreground" src="@/assets/img/Bush_left.png">
    </div>
    <div id="treeLayer">
    </div>
    <div id="butterflyLayer">
    </div>
    <div id="signboardLayer">
      <img v-if="this.currentGroup.trunk != ''" src="@/assets/img/Signboard.png" width="100%">
      <img v-else src="@/assets/img/Signboard_Cultivation.png" width="100%">
      <div id="signboardText">
        <p class="text-center">{{ purposeTrunk }}</p>
      </div>
    </div>
    <div id="callToActionLayer">
    </div>
    <div id="wishLayer">
      <svg class="treeItem" id="wishSvg" width="100%"></svg>
    </div>
    <div id="groupLabel">
      <h4 class="text-center">{{ this.currentGroup.group }}</h4>
    </div>
    <div id="mapLogo" @click="treeToForest" @mouseover="iconHoverIn" @mouseout="iconHoverOut">
      <img class="icon" src="@/assets/img/UI_Map.png">
    </div>
  </div>
</template>

<script>
import * as d3 from "d3"
import { mapState } from 'vuex'

export default {
    name: "TreeView",
    data: () => ({
      tree: {},
    }),
    computed: {
      ...mapState([
        "currentGroup",
        "currentWishes",
      ]),
      purposeTrunk: function() {
        return this.currentGroup.trunk;
      },
    },
    methods: {
      drawTree: function(treeType) {
        // 95 slots
        let matureTree = {
            type: "mature",
            img: require("@/assets/img/Tree_mature.png"),
            rows: 7,
            columns: 20,
            svgwidth: 1000,
            svgheight: 660,
            treeScale: 0.6,
            mask: [
              [0,0,0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0],
              [0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0],
              [0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0],
              [0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0],
              [0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0],
              [1,1,1,1,1,1,1,1,0,0,0,1,1,1,1,1,1,1,1,0],
              [1,1,1,1,1,1,1,0,0,0,0,1,1,1,1,1,1,1,1,1],
            ],
            callToAction: require("@/assets/img/CTA_Mature.png")
        };

        // 60 slots
        let youngAdultTree = {
            type: "youngadult",
            img: require("@/assets/img/Tree_youngadult.png"),
            rows: 7,
            columns: 14,
            svgwidth: 740,
            svgheight: 560,
            treeScale: 0.45,
            mask: [
              [0,0,0,0,0,1,1,1,1,0,0,0,0,0],
              [0,0,0,0,1,1,1,1,1,1,0,0,0,0],
              [0,0,0,1,1,1,1,1,1,1,1,1,0,0],
              [0,0,1,1,1,1,1,1,1,1,1,1,0,0],
              [0,1,1,1,1,1,0,0,1,1,1,1,1,0],
              [1,1,1,1,1,0,0,0,1,1,1,1,1,0],
              [1,1,1,1,1,0,0,0,1,1,1,1,1,1],
            ],
            callToAction: require("@/assets/img/CTA_Young.png")
        };

        // 36 slots
        let saplingTree = {
            type: "sapling",
            img: require("@/assets/img/Tree_sapling.png"),
            rows: 6,
            columns: 11,
            svgwidth: 600,
            svgheight: 590,
            treeScale: 0.3,
            mask: [
              [0,0,0,0,0,1,1,0,0,0,0],
              [0,0,0,0,1,1,1,1,0,0,0],
              [0,0,0,1,1,1,1,1,1,0,0],
              [0,0,1,1,1,1,1,1,0,0,0],
              [0,1,1,1,1,0,1,1,1,1,1],
              [1,1,1,1,0,0,1,1,1,1,1],
            ],
            callToAction: require("@/assets/img/CTA_Sapling_2.png")
        };

        if (treeType == "sapling") {
          this.tree = saplingTree;
        } else if (treeType == "youngadult") {
          this.tree = youngAdultTree;
        } else if (treeType == "mature") {
          this.tree = matureTree;
        } else if (treeType == "newtree") {
          this.tree = saplingTree;
          this.tree.callToAction = require("@/assets/img/CTA_Sapling_1.png");
        }

        d3.select("#treeLayer img").remove();
        d3.select("#callToActionLayer img").remove();

        d3.select("#treeLayer")
            .append("img")
            .attr("class", "treeItem")
            .attr("src", this.tree.img);

        d3.select("#callToActionLayer")
            .append("img")
            .style("width", "300px")
            .attr("src", this.tree.callToAction);
      },
      layoutScene: function () {
        let height = window.innerHeight;
        let width = window.innerWidth;
        let treescale = (width > 800) ? this.tree.treeScale * width : this.tree.treeScale * 750;
        if (treescale > 1000) treescale = 1000;

        if (width > 800) {
            d3.select("#treeLayer")
            .style("left", (width/2 - treescale/2) + "px")
            .style("bottom", (width * 0.07) + "px");
            
            d3.select("#wishLayer")
            .style("left", (width/2 - treescale/2) + "px")
            .style("bottom", (width * 0.07) + "px");

            d3.selectAll(".treeItem").style("width", treescale + "px");
            d3.selectAll(".midground").style("bottom", (width * 0.16) + "px");

            d3.select("#callToActionLayer").style("top", "5%");

            if (width > 1200) {
              d3.select("#balloonLayer")
              .style("left", "0px")
              .style("top", "-400px");

              d3.select("#signboardText p").style("font-size", + (35 - this.currentGroup.textLength / 15) + "px");
            } else {

              if (height > 800) {
                d3.select("#balloonLayer")
                .style("left", "0px")
                .style("top", "300px");
              } else {
                d3.select("#balloonLayer")
                .style("left", "0px")
                .style("top", "0px");
              }

              d3.select("#signboardText p").style("font-size", + (27 - this.currentGroup.textLength / 15) + "px");
            }
         } else {
            d3.select("#balloonLayer")
            .style("left", "0px")
            .style("top", "-200px");

            d3.select("#treeLayer")
            .style("left", (width/2 - treescale/2) + "px")
            .style("bottom", "280px");
            
            d3.select("#wishLayer")
            .style("left", (width/2 - treescale/2) + "px")
            .style("bottom", "280px");

            d3.selectAll(".treeItem").style("width", treescale + "px");
            d3.selectAll(".midground").style("bottom", "330px");

            d3.select("#callToActionLayer").style("top", "1%");
            d3.select("#signboardText p").style("font-size", + (29 - this.currentGroup.textLength / 15) + "px");
        }
      },
      shuffleArray: function(array) {
          for (var i = array.length - 1; i > 0; i--) {
              var j = Math.floor(Math.random() * (i + 1));
              var temp = array[i];
              array[i] = array[j];
              array[j] = temp;
          }
      },
      drawWishLayer: function() {
        let dataspace = [];

        for (let j=0; j < this.tree.rows; j++) {
            for(let i=0; i < this.tree.columns; i++) {
                let obj = {};
                
                obj.x = i * 50 + 25 + Math.floor(j % 2) * 25;
                obj.y = j * 50 + 25;
                
                if (this.tree.mask[j][i] == 1) {
                    dataspace.push(obj);
                }
            }   
        }

        this.shuffleArray(dataspace);

        this.currentWishes.forEach((d,i) => {
          d.x = dataspace[i].x;
          d.y = dataspace[i].y;
          d.index = i;
        })

        d3.selectAll("svg#wishSvg g").remove();

        // draw layer in SVG
        let wishlayer = d3.select("svg#wishSvg")
            .attr("viewBox", "0 0 " + this.tree.svgwidth + " " + this.tree.svgheight)
            .selectAll("g")
            .data(this.currentWishes)
            .enter()
            .append("g");
            
            wishlayer
            .append("circle")
            .attr("cx", d => d.x)
            .attr("cy", d => d.y)
            .attr("r", 25)
            .style("fill", "transparent")
            .on("mouseover", (event) => {
                d3.select(event.currentTarget)
                .attr("stroke", "yellow")
                .attr("stroke-width", 3);

                d3.select(event.currentTarget.parentNode).select("image")
                  .attr("href", require("@/assets/img/WishJar_hover.png"));
            }) 
            .on("mouseout", (event) => {
                d3.select(event.currentTarget)
                .attr("stroke", "none");

                d3.select(event.currentTarget.parentNode).select("image")
                  .attr("href", require("@/assets/img/WishJar.png"));
            })
            .on("click", (event, d) => {
                this.$emit("treeToSky", d.index);
            })

            wishlayer
            .append("image")
            .attr("xlink:href", () => {
                return require("@/assets/img/WishJar.png");
            })
            .attr("x", d => d.x - 30)
            .attr("y", d => d.y -30)
            .attr("width", 60)
            .attr("height", 60)
            .attr("pointer-events", "none");
      },
      // cloudScene: function() {
      // },
      iconHoverIn: function() {
        d3.select("div#mapLogo img")
        .attr("src", require("@/assets/img/UI_Map_hover.png"))
      },
      iconHoverOut: function() {
        d3.select("div#mapLogo img")
        .attr("src", require("@/assets/img/UI_Map.png"))
      },
      treeToForest: function() {
        this.$emit("treeToForest");
      }
    },
    created: function () {
        window.addEventListener("resize", this.layoutScene);
    },
    destroyed() {
        window.removeEventListener("resize", this.layoutScene);
    },
    mounted: function () {
      this.layoutScene();
    }
}
</script>

<style scoped>
#treeView {
  overflow: hidden;
}

.background {
  position: absolute;
  width: 100vw;
  bottom: 0%;
}

.midground {
    position: absolute;
    width: 100vw;
}

.foreground {
    position: absolute;
    width: 100vw;
    bottom: 0%;
}

.foreground2 {
    position: absolute;
    left: -800px;
    width: 800px;
}

#callToActionLayer {
  position: absolute;
  top: 5%;
  left: 0%;
}

#balloonLayer {
  position: absolute;
}

#balloon1 {
  position: absolute;
  top: 50px;
  left: -50px;
}

#balloon2 {
  position: absolute;
  top: -150px;
  left: -50px;
}

#balloon3 {
  position: absolute;
  top: 100px;
  left: -50px;
}

#balloon4 {
  position: absolute;
  top: -50px;
  left: -50px;
}

#treeLayer {
  position: absolute;
}

#wishLayer {
  position: absolute;
}

#butterflyLayer {
  position: absolute;
  width: 100%;
  height: 200px;
  bottom: 0%;
}


.treeItem {
  /* border: solid 1px red; */
}

#mapLogo {
  position: absolute;
  left: 50%;
  bottom: 0%;
  transform: translate(-50%, 0)
}

.icon {
  width: 100px;
}

#signboardLayer {
  position: absolute;
  width: 470px;
  right: 5%;
  bottom: 0%;
}

#signboardText {
  position: absolute;
  width: 88%;
  right: 5%;
  bottom: 23%;
  height: 150px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;  
}

#signboardText p{
  line-height: 1.2;
  margin-top: 0px;
  margin-bottom: 0px;
  color: white;
}

#groupLabel {
  position: absolute;
  left: 3%;
  bottom: 3%;
}

#groupLabel h4 {
  color: white;
}

@media only screen and (max-width: 1200px) {
  #signboardLayer {
    width: 330px;
  }

  #signboardText {
    height: 100px;
  }
}

@media only screen and (max-width: 800px) {
  .background {
      bottom: 250px;
  }
  
  .foreground {
      bottom: 33%;
      left: -100%;
  }

  .foreground2 {
      left: 0%;
      bottom: 0%;
  }

  #signboardLayer {
    width: 360px;
    left: 50%;
    bottom: 3%;
    transform: translate(-50%, 0)
  }

  #signboardText {
    height: 170px;
    bottom: 10%;
  }

  #groupLabel {
    left: 50%;
    bottom: 220px;
    width: 80%;
    transform: translate(-50%, 0)
  }

  .icon {
    width: 70px;
  }
}


</style>
